import React, { useState } from 'react';
import { salesStorage } from '../../services/localStorage.service';
import './SalesEntry.css';

const SalesEntry = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [formData, setFormData] = useState({
    patientName: '',
    contactNumber: '',
    referBy: '',
    patientType: 'OPD (Outpatient Department)',
    doctorName: '',
    patientSellAmount: '',
    returnAmount: '',
    discount: '',
    paymentType: 'Cash',
    collectedAmount: '',
    remainingAmount: '0.00',
    reasonForRemaining: '',
    responsiblePerson: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Calculate remaining amount
    if (name === 'patientSellAmount' || name === 'returnAmount' || name === 'discount' || name === 'collectedAmount') {
      const sellAmount = parseFloat(formData.patientSellAmount || 0);
      const returnAmt = parseFloat(formData.returnAmount || 0);
      const disc = parseFloat(formData.discount || 0);
      const collected = parseFloat(formData.collectedAmount || 0);
      
      const total = sellAmount - returnAmt - disc;
      const remaining = total - collected;
      
      setFormData(prev => ({
        ...prev,
        remainingAmount: remaining > 0 ? remaining.toFixed(2) : '0.00'
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsSubmitting(true);

    try {
      const saleData = {
        patient_name: formData.patientName,
        patientName: formData.patientName,
        contact_number: formData.contactNumber || null,
        contactNumber: formData.contactNumber,
        refer_by: formData.referBy || null,
        referBy: formData.referBy,
        patient_type: formData.patientType || 'OPD',
        patientType: formData.patientType,
        doctor_name: formData.doctorName || null,
        doctorName: formData.doctorName,
        patient_sell_amount: parseFloat(formData.patientSellAmount || 0),
        patientSellAmount: parseFloat(formData.patientSellAmount || 0),
        return_amount: parseFloat(formData.returnAmount || 0),
        returnAmount: parseFloat(formData.returnAmount || 0),
        discount: parseFloat(formData.discount || 0),
        payment_type: formData.paymentType || 'Cash',
        paymentType: formData.paymentType,
        collected_amount: parseFloat(formData.collectedAmount || 0),
        collectedAmount: parseFloat(formData.collectedAmount || 0),
        remaining_amount: parseFloat(formData.remainingAmount || 0),
        remainingAmount: parseFloat(formData.remainingAmount || 0),
        reason_for_remaining: formData.reasonForRemaining || null,
        reasonForRemaining: formData.reasonForRemaining,
        responsible_person: formData.responsiblePerson || null,
        responsiblePerson: formData.responsiblePerson,
      };

      const newSale = salesStorage.create(saleData);
      
      if (newSale) {
        setSuccess('Sale recorded successfully!');
        // Reset form
        setFormData({
          patientName: '',
          contactNumber: '',
          referBy: '',
          patientType: 'OPD (Outpatient Department)',
          doctorName: '',
          patientSellAmount: '',
          returnAmount: '',
          discount: '',
          paymentType: 'Cash',
          collectedAmount: '',
          remainingAmount: '0.00',
          reasonForRemaining: '',
          responsiblePerson: '',
        });
        setTimeout(() => setSuccess(''), 3000);
      } else {
        setError('Failed to record sale. Please try again.');
      }
    } catch (err) {
      console.error('Error creating sale:', err);
      setError('Failed to record sale. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="sales-entry">
      <div className="sales-entry-header">
        <h1 className="page-title">Sales Entry</h1>
        <p className="page-subtitle">Record New Sale</p>
      </div>
      {error && (
        <div style={{ 
          color: '#ef4444', 
          padding: '10px', 
          marginBottom: '15px', 
          backgroundColor: '#fee2e2', 
          borderRadius: '4px',
          textAlign: 'center'
        }}>
          {error}
        </div>
      )}
      {success && (
        <div style={{ 
          color: '#10b981', 
          padding: '10px', 
          marginBottom: '15px', 
          backgroundColor: '#d1fae5', 
          borderRadius: '4px',
          textAlign: 'center'
        }}>
          {success}
        </div>
      )}
      <div className="sales-entry-card">
        <form onSubmit={handleSubmit} className="sales-entry-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="patientName">Patient Name</label>
              <input
                type="text"
                id="patientName"
                name="patientName"
                value={formData.patientName}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter Name"
              />
            </div>
            <div className="form-group">
              <label htmlFor="contactNumber">Contact Number</label>
              <input
                type="text"
                id="contactNumber"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter Number"
              />
            </div>
            <div className="form-group">
              <label htmlFor="referBy">Refer by</label>
              <input
                type="text"
                id="referBy"
                name="referBy"
                value={formData.referBy}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter Name"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="patientType">Patient Type</label>
              <select
                id="patientType"
                name="patientType"
                value={formData.patientType}
                onChange={handleChange}
                className="form-input"
              >
                <option>OPD (Outpatient Department)</option>
                <option>IPD (Inpatient Department)</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="doctorName">Doctor Name</label>
              <input
                type="text"
                id="doctorName"
                name="doctorName"
                value={formData.doctorName}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter Name"
              />
            </div>
            <div className="form-group">
              <label htmlFor="patientSellAmount">Patient Sell Amount</label>
              <input
                type="number"
                id="patientSellAmount"
                name="patientSellAmount"
                value={formData.patientSellAmount}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter amount"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="returnAmount">Return Amount</label>
              <input
                type="number"
                id="returnAmount"
                name="returnAmount"
                value={formData.returnAmount}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter amount"
              />
            </div>
            <div className="form-group">
              <label htmlFor="discount">Discount</label>
              <input
                type="number"
                id="discount"
                name="discount"
                value={formData.discount}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter amount"
              />
            </div>
            <div className="form-group">
              <label htmlFor="paymentType">Payment Type</label>
              <select
                id="paymentType"
                name="paymentType"
                value={formData.paymentType}
                onChange={handleChange}
                className="form-input"
              >
                <option>Cash</option>
                <option>Credit</option>
                <option>Card</option>
                <option>UPI</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="collectedAmount">Collected Amount</label>
              <input
                type="number"
                id="collectedAmount"
                name="collectedAmount"
                value={formData.collectedAmount}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter amount"
              />
            </div>
            <div className="form-group">
              <label htmlFor="remainingAmount">Remaining Amount</label>
              <input
                type="text"
                id="remainingAmount"
                name="remainingAmount"
                value={formData.remainingAmount}
                readOnly
                className="form-input"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </div>
          </div>

          <div className="form-row full-width">
            <div className="form-group">
              <label htmlFor="reasonForRemaining">Reason for Remaining Amount</label>
              <textarea
                id="reasonForRemaining"
                name="reasonForRemaining"
                value={formData.reasonForRemaining}
                onChange={handleChange}
                className="form-input"
                rows="3"
                placeholder="Enter reason if any amount remains outstanding"
              />
            </div>
          </div>

          <div className="form-row full-width">
            <div className="form-group">
              <label htmlFor="responsiblePerson">Responsible Person</label>
              <input
                type="text"
                id="responsiblePerson"
                name="responsiblePerson"
                value={formData.responsiblePerson}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter name of responsible person"
              />
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
              {isSubmitting ? 'Recording...' : 'Save Sale'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SalesEntry;

